export default "__VITE_ASSET__bcbde463__"